export const IOS_APP_STORE_URL = 'https://apps.apple.com/app/id6754179327';
export const ANDROID_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.den.wallet';

type MobileStorePlatform = 'ios' | 'android';

export function getMobileStorePlatform(
  userAgent: string
): MobileStorePlatform | null {
  const normalizedUserAgent = userAgent.toLowerCase();

  if (
    /(iphone|ipad|ipod)/.test(normalizedUserAgent) ||
    (normalizedUserAgent.includes('macintosh') &&
      normalizedUserAgent.includes('mobile'))
  ) {
    return 'ios';
  }

  if (normalizedUserAgent.includes('android')) {
    return 'android';
  }

  return null;
}

export function getMobileStoreUrl(userAgent: string): string | null {
  const platform = getMobileStorePlatform(userAgent);

  if (platform === 'ios') {
    return IOS_APP_STORE_URL;
  }

  if (platform === 'android') {
    return ANDROID_PLAY_STORE_URL;
  }

  return null;
}
